import React from 'react';
import './styles.scss';

const ContentContainer = ({ fullWidth, loadingSpinner, children, ...props }) => {
  let classNames = 'styled-content-container';
  if (fullWidth) classNames += ' full-width';
  if (loadingSpinner) classNames += ' loading-spinner';

  return (
    <div className={classNames} {...props}>
      {children}
    </div>
  );
};

export default ContentContainer;
